import { Routes } from '@angular/router';
import { environment } from '../environments/environment';

export const routes: Routes = [
  {
    path: 'inventory',
    children: [
      {
        path: 'top',
        data: { viewCd: 'top' },
        loadComponent: () =>
          import('./report/top.component').then((m) => m.TopComponent),
      },
      {
        path: 'report-list',
        data: { viewCd: 'report-list' },
        loadComponent: () =>
          import('./report/report-list/report-list.component').then(
            (m) => m.ReportListComponent
          ),
      },
      {
        path: 'report-list/:workMode',
        loadComponent: () =>
          import('./report/report-list/report-list.component').then(
            (m) => m.ReportListComponent
          ),
      },
      {
        path: '',
        redirectTo: 'top',
        pathMatch: 'full',
      },
      // ui-editerルート（開発環境のみ）
      ...(!environment.production
        ? [
            {
              path: 'ui-editer',
              loadComponent: () =>
                import('./report/ui-editer/ui-editer.component').then(
                  (m) => m.UiEditerComponent
                ),
            },
            {
              path: 'report-list-field-json-editer',
              loadComponent: () =>
                import(
                  './report/ui-editer/report-list-field-json-editer.component'
                ).then((m) => m.ReportListFieldJsonEditerComponent),
            },
          ]
        : []),
    ],
  },
  {
    path: '',
    redirectTo: 'inventory',
    pathMatch: 'full',
  },
];
